import ajax from '../utils/ajax'
import { PACKAGE_PRICE_CACHE_ENDPOINT } from '../constants/API-Endpoints'
import get from 'lodash/get'
import isNil from 'lodash/isNil'

const searchPackageCache = (callback, { latitude, longitude, isVariant }) => {
  const vacationLength = isVariant ? `?min-vacation-length=2` : ''
  const numOfChildren = isVariant ? '&num-children=0' : ''
  const numOfInfants = isVariant ? '&num-infants=0' : ''
  const startDayOfWeek = isVariant ? '&start-day-of-week=4' : ''
  const numDateRanges = isVariant ? '&num-date-ranges=3' : ''
  const latLongSeparator = isVariant ? '&' : '?'
  const latAndLong = latitude && longitude
    ? `${latLongSeparator}latitude=${latitude}&longitude=${longitude}`
    : ''
  const queryString = `${vacationLength}${numOfChildren}${numOfInfants}${startDayOfWeek}${numDateRanges}${latAndLong}`

  ajax({
    headers: {
      'Cache-Control': 'private, max-age=900'
    },
    url: `${PACKAGE_PRICE_CACHE_ENDPOINT}${queryString}`,
    type: 'GET'
  })
    .then(({ data: { packages = [] } = {} }) =>
      callback(
        packages.map(pkg => {
          return {
            ...pkg,
            id: `PACKAGE_DEAL_${pkg.cityName.slice(-2)}`,
            image: pkg.cityImageUrl,
            imageHeight: '284px',
            gaCategory: 'Package_Home',
            gaAction: 'Cached Deal',
            strikePrice:
              pkg.priceAmount < pkg.retailPriceAmount
                ? pkg.retailPriceAmount
                : 0,
            gaLabel: pkg.cityName,
            navArray: [
              {
                href: pkg.searchLink,
                target: '_blank'
              }
            ]
          }
        })
      )
    )
    .catch((err) => {
      window.PCLN.Analytics.logWarning({
        name: 'Package Price Cache Error',
        message: err.message
      })

      callback([]) // eslint-disable-line standard/no-callback-literal
    })
}

export default function (callback, options = {}) {
  if (
    !isNil(get(window, 'PCLN_BOOTSTRAP_DATA.locale.latitude')) &&
    !isNil(get(window, 'PCLN_BOOTSTRAP_DATA.locale.longitude'))
  ) {
    searchPackageCache(callback, options)
  } else if (window && window.navigator && window.navigator.geolocation) {
    window.navigator.geolocation.getCurrentPosition(
      position => {
        options.latitude = position.coords.latitude
        options.longitude = position.coords.longitude
        searchPackageCache(callback, options)
      },
      () => {
        searchPackageCache(callback, options)
      }
    )
  }
}
